export default {
  name: 'purchaseConfirm',

  bindings: {
    purchase: '<'
  },
  controller: ['$state', '$http', '$window',
    class {
      constructor($state, $http, $window) {
        this.$state = $state;
        this.$http = $http;
        this.sending = false;
        this.$window = $window;
      }

      $onInit() {
        if (this.loggedUser) {
          this.ccSeleccionada = "";
        }
      }

      disabled(datosPersonales) {
        return this.sending || (!this.loggedUser && (!datosPersonales.$dirty || datosPersonales.$invalid)) || (this.loggedUser && this.verInputCC && !this.cuentaNoHabitualSeleccionada());
      }

      $postLink() {
        this.loggedUser = !(this.$window.location.href.indexOf('publica') !== -1);
        setTimeout(() => VMasker(document.querySelector(".cuentacorriente")).maskPattern("9999-9999-9999-9999-9999"), 0);
      }

      confirmarPedido() {
        this.sending = true;
        if (this.loggedUser) {
          return this.makeOrder();
        } else {
          this.$http.post(
              '/oferta/validatepersona',
              this.persona
          ).then(response => {
            try {
              JSON.parse(JSON.stringify(response.data));
              this.errors = response.data;
              if (Object.keys(this.errors).length === 0) {
                return this.makeOrder();
              }
            } catch (e) {
              console.error(e);
              console.log(response.data);
              alert("Se ha producido un error.");
            }

          });
        }
      }

      makeOrder() {
        return this.$http.post(
            '/oferta/makeorder',
            this.getPayload()
        ).then(
            (response) => {
              try {
                JSON.parse(JSON.stringify(response.data));
              } catch (e) {
                console.error(e);
                console.log(response.data);
                alert("Se ha producido un error.");
              }
              this.$state.go('success')
            });
      }

      goBack() {
        this.$state.go('list');
      }

      getPayload() {
        return {
          cc: (this.cuentaNoHabitualSeleccionada()) ? this.ccSeleccionada : -1,
          persona: this.persona,
          cesta: this.purchase.cestaToPair()
        };
      }

      cuentaNoHabitualSeleccionada() {
        let b = typeof this.ccSeleccionada === 'string' && this.ccSeleccionada.length > 0;
        return b;
      }

      toggleCuentaHabitual() {
        this.verInputCC = !this.verInputCC;
        setTimeout(() => VMasker(document.querySelector(".cuentacorriente")).maskPattern("9999-9999-9999-9999-9999"), 0);
      }
    }
  ],
  templateUrl: '/template/render/?tpl=/oferta-navidad/purchaseConfirm.php'
};


// WEBPACK FOOTER //
// ./oferta-navidad/purchaseConfirmComponent.js